<template>
  <a-modal
    v-model:visible="visible"
    title="版本信息"
    ok-text="关闭"
    @ok="handleok"
  >
    <!-- <div>应用名称：{{ appInfo?.name }}</div> -->
    <div>
      应用框架版本：v{{ editorVersion }}
      <span v-if="versionTypeLabel">
        {{ versionTypeLabel }}
      </span>
    </div>
    <div>
      应用版本（发布时间）：{{ _getFormatTime() }}
      <a-button type="primary" size="small" @click="handleRefresh">{{
        needUpdate ? '更新' : '重新加载'
      }}</a-button>
    </div>

    <!-- 历史版本列表 -->
    <div v-if="versionHistoryEnabled" class="mt-4">
      <div class="text-sm font-medium mb-2">历史版本：</div>
      <a-spin :spinning="versionHistoryLoading">
        <div v-if="historyVersions.length" class="space-y-2">
          <div
            v-for="item in historyVersions"
            :key="item.buildTime"
            class="flex items-center justify-between px-3 py-2 rounded bg-[#1f1f1f] hover:bg-[#2a2a2a] cursor-pointer"
            @click="handleSwitchVersion(item)"
          >
            <span class="text-sm opacity-80">{{
              formatBuildTime(item.buildTime)
            }}</span>
            <a-button type="link" size="small">切换</a-button>
          </div>
        </div>
        <div v-else class="text-sm opacity-50">暂无历史版本</div>
      </a-spin>
    </div>

    <template #footer>
      <a-button @click="handleok">关闭</a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { computed, nextTick, ref } from 'vue';
import { useWebVersion } from '@/hooks';
import { getEditorVersion } from '@/utils/version.utils';
import { ElectronApi } from '@/services/electron.api';
import {
  useVersionHistory,
  VersionHistoryItem
} from '@/hooks/use-version-history';
import dayjs from 'dayjs';

// const appInfo = ref<AppInfo>();
// onMounted(async () => (appInfo.value = await ElectronApi.getAppInfo()));

let editorVersion = ref<string>('');
const visible = ref<boolean>(false);

// 历史版本
const {
  enabled: versionHistoryEnabled,
  versions: historyVersions,
  loading: versionHistoryLoading,
  fetchVersions,
  switchToVersion
} = useVersionHistory();

defineExpose({
  open: async () => {
    visible.value = true;
    await nextTick();
    editorVersion.value = await getEditorVersion();
    await checkVersion();
    // 拉取历史版本
    fetchVersions();
  }
});

const handleok = () => {
  visible.value = false;
};

const versionType = computed(() => ElectronApi.versionType());
const versionTypeLabel = computed(() => {
  const type = versionType.value;
  if (type == 'professional') {
    return '专业版';
  } else if (type == 'staging') {
    return '内测版';
  } else {
    return '';
  }
});

/*应用版本发布时间*/
const { getBuildTime, checkVersion, reloadWeb } = useWebVersion();
const _getFormatTime = () => {
  const time = getBuildTime();
  return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
};

const formatBuildTime = (buildTime: string) => {
  return dayjs(buildTime).format('YYYY-MM-DD HH:mm:ss');
};

const needUpdate = ref(false);
const handleRefresh = () => {
  handleok();
  reloadWeb();
};

const handleSwitchVersion = (item: VersionHistoryItem) => {
  switchToVersion(item);
};
</script>

<style scoped>
._drag {
  -webkit-app-region: drag;
}
._no_drag {
  -webkit-app-region: no-drag;
}
</style>
